import { baseApi } from "./baseAPI";
import { RolesList } from "../dtos/authentication/role";
import { user } from "../dtos/authentication/user";

export const userApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAllUsers: build.query<user[], void>({
            query: () =>{
                return 'User'
            },
            providesTags:() => [{type: 'Users', value: "LIST"}],
        }),
        getUserRequest: build.query<user, number>({
            query: (id) => ({
                url: `User/${id}`,
                method: "GET"
            }),
            providesTags:(user) => [{type: 'User', value: user?.userName}]
        }),
        getAllRoles: build.query<RolesList, void>({
            query: () =>{
                return 'User/Roles'
            },
            providesTags:() => [],
        }),
        updateUser: build.mutation<user, user>({
            query: (body) => ({
                url: `User`,
                method: 'PUT',
                body
            }),
            invalidatesTags: (user) => [{type: 'Users', value:'LIST'}, {type: 'User', value: user?.userName}]
        }),
        createUser: build.mutation<{ password: string }, user>({
            query: (body) => ({
                url: `User`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (__, _, user) => [{type: 'Users', value:'LIST'}, {type: 'User', value: user?.userName}]
        }),
        deleteUser: build.mutation<string, number>({
            query: (id) => ({
                url: `User/${id}/Delete`,
                method: 'PATCH'
            }),
            invalidatesTags: () => [{type: 'Users', value:'LIST'}]
        }),
        reactivateUser: build.mutation<string, number>({
            query: (id) => ({
                url: `User/${id}/activate`,
                method: 'PATCH'
            }),
            invalidatesTags: () => [{type: 'Users', value:'LIST'}]
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetAllUsersQuery,
    useGetAllRolesQuery,
    useUpdateUserMutation,
    useCreateUserMutation,
    useDeleteUserMutation,
    useReactivateUserMutation,
    useGetUserRequestQuery
} = userApi
